module.exports = __webpack_public_path__ + "img/upgrade.1fa8071e.svg";